export default {
      id: "half_moon-usage",
      viewBox: "0 0 16 30",
      url: __webpack_public_path__ + "icons.svg#half_moon",
      toString: function () {
        return this.url;
      }
    }